import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import axios, { AxiosError, AxiosResponse } from 'axios';

import Subscription from '../../../src/models/subscription';

import { useMicrosoft } from '../../_libs/hooks/useMicrosoft';
import MicrosoftSSOWidget from '../../molecules/MicrosoftSSOWidget';
import StandardPageTemplate from '../../templates/StandardPage';
import SubscriptionTable from '../../organisms/SubscriptionTable';

// NOTE: Consider elevating to the Microsoft provider
function fetchSubscriptionsForUserId (graphUserId: string, cb: (subscriptions: any) => void) {
  axios
    .get(`/apis/microsoft/subscriptions/user/${graphUserId}/`)
    .then(
      (res: AxiosResponse) => {
        if (res.data.status === 'OK' && res.data.subscriptions) {
          cb(res.data.subscriptions);
        } else {
          console.error('<SubscriberSubscriptions> Error getting subscriptions for user.');
        }
      },
      (err: AxiosError) => {
        console.error(`<SubscriberSubscriptions> Error getting subscriptions: ${err}.`);
      },
    );
}

const SubscriberSubscriptionsPage = (): JSX.Element => {
  const {
    error,
    graphData,
  } = useMicrosoft();
  const [subscriptions, setSubscriptions] = useState<Subscription[]>();

  useEffect(() => {
    if (graphData) {
      fetchSubscriptionsForUserId(graphData.id, setSubscriptions);
    }
  }, [graphData]);

  let content = <p>Loading subscriptions...</p>;
  if (!graphData) {
    content = <MicrosoftSSOWidget error={error} type={'subscriber'} />;
  } else if (subscriptions) {
    content = <SubscriptionTable subscriptions={subscriptions} userType="subscriber" />;
  } else {
    content = <p>Could not find subscriptions associated with your account.</p>;
  }

  return (
    <StandardPageTemplate>
      <h1 className="f-serif f-normal f-italic">Your Subscriptions</h1>
      {content}
    </StandardPageTemplate>
  );
};

export default SubscriberSubscriptionsPage;
